import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { StorageKeys } from '../../../../enums/storage-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private readonly cookieService: CookieService) {}

  get<T = any>(key: StorageKeys): T | null {
    const result = localStorage?.getItem(key) || this.cookieService.get(key);
    return result ? (JSON.parse(result) as T) : null;
  }

  set<T = any>(key: StorageKeys, value: T): void {
    localStorage?.setItem(key, JSON.stringify(value));
  }

  clear(key: StorageKeys): void {
    localStorage?.removeItem(key);
    this.cookieService.delete(key);
  }

  clearAll(): void {
    const appLang = localStorage.getItem('app-lang');
    localStorage.clear();
    if (appLang) {
      localStorage.setItem('app-lang', appLang);
    }
  }
}
